export default __webpack_public_path__ + "static/media/Icon23.10aff4ec.svg";